"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _usePrevious = _interopRequireDefault(require("../usePrevious"));

var _tabsModule = _interopRequireDefault(require("./tabs.module.scss"));

var _excluded = ["active", "index", "disabled", "label", "onActive", "onClick", "children", "icon", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var noop = function noop() {};

var Tab = function Tab(_ref) {
  var active = _ref.active,
      index = _ref.index,
      disabled = _ref.disabled,
      label = _ref.label,
      onActive = _ref.onActive,
      onClick = _ref.onClick,
      children = _ref.children,
      icon = _ref.icon,
      className = _ref.className,
      others = _objectWithoutProperties(_ref, _excluded);

  var firstUpdate = (0, _react.useRef)(true);
  var prevActive = (0, _usePrevious["default"])(active);
  (0, _react.useEffect)(function () {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    } // only trigger callback if active prop changed


    if (!prevActive && active) {
      onActive();
    }
  }, [active, onActive, prevActive]);
  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, others, {
    role: "tab",
    tabIndex: "0",
    className: (0, _classnames["default"])(_tabsModule["default"].tab, className, _defineProperty({}, _tabsModule["default"].disabled, disabled), _defineProperty({}, _tabsModule["default"].active, active)),
    onClick: (0, _react.useCallback)(function (e) {
      if (onClick && !disabled) {
        onClick(e, index);
      }
    }, [disabled, index, onClick])
  }), icon, label, children, /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])(_tabsModule["default"].span, _defineProperty({}, _tabsModule["default"].active, active))
  }));
};

Tab.propTypes = {
  index: _propTypes["default"].number,
  children: _propTypes["default"].node,
  icon: _propTypes["default"].node,
  className: _propTypes["default"].string,
  active: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  label: _propTypes["default"].node,
  onActive: _propTypes["default"].func,
  onClick: _propTypes["default"].func
};
Tab.defaultProps = {
  index: 0,
  children: null,
  icon: null,
  className: '',
  active: false,
  disabled: false,
  label: '',
  onActive: noop,
  onClick: null
};
var _default = Tab;
exports["default"] = _default;